import React, { Component } from 'react'
import { Link } from "react-router-dom"
import AOS from 'aos';
import Button from "../../components/Button"
import arrowright from "../../assets/images/arrow-right.svg"
import telegramchannel from "../../assets/images/telegramchannel.png"
import checkbox from "../../assets/images/checkbox.svg"
import bulletpoint from "../../assets/images/bulletpoint.svg"
import imac from "../../assets/images/imac.png"
import cpIcon1 from "../../assets/images/cpIcon1.svg"
import timingIcon from "../../assets/images/timingIcon.svg"
import communityIcon from "../../assets/images/communityIcon.svg"
import composition from "../../assets/images/Composition.png"
import checkmark from "../../assets/images/checkmark.svg"

class GetStarted extends Component {
    componentDidMount() {
        // or simply just AOS.init();
        AOS.init({
          // initialise with other settings
          duration : 1000
        });
      }
    render() {
        return (
            <>
                <div className="get-started">
                    <div className="get-started-content">
                        <div className="cp-body">
                            <div className="newGetStarted">
                                <h4 className="step-head">HOW TO GET STARTED WITH OUR <br /> <span>FOREX TRADING COURSE</span></h4>
                                <div className="course-process">
                                    <div className="step" data-aos="fade-up" data-aos-delay="60" data-aos-duration="1400">
                                        <div className="step-no">
                                            <h4>01</h4>
                                            <p className="vrt-green"></p>
                                        </div>
                                        <div className="step-details">
                                            <h4>SIGN UP & REGISTER</h4>
                                            <h6>Sign up by entering appropriate and correct details in the sign-up form. Choose preferred plan and register.</h6>
                                        </div>
                                    </div>
                                    <div className="step" data-aos="fade-up" data-aos-delay="80" data-aos-duration="1600">
                                        <div className="step-no">
                                            <h4>02</h4>
                                            <p className="vrt-green"></p>
                                        </div>
                                        <div className="step-details">
                                            <h4>ENTER PAYMENT DETAILS</h4>
                                            <h6>Once done with registration, proceed with entering payment details after choosing your most preferred payment method.</h6>
                                        </div>
                                    </div>
                                    <div className="step" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1800">
                                        <div className="step-no">
                                            <h4>03</h4>
                                        </div>
                                        <div className="step-details">
                                            <h4>GET RESOURCES & START LEARNING</h4>
                                            <h6>Once payment is confirmed, you get access to the educational contents. Go through them at your convenience. Learn and go pro!</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="read-more-button">
                                    <Link to="/academy">
                                        <Button className="read-more"><p>Go to Academy</p>
                                            <img src={arrowright} alt="arrow right" />
                                        </Button>
                                    </Link>
                                </div>
                            </div>
                            <div className="cp-img" data-aos="zoom-in-left" data-aos-delay="100" data-aos-duration="1700">
                                <img src={imac} alt="imac mockup" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cp-card-body">
                    <div className="cp-card-body-content" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1800">
                        <div className="cp-card">
                            <img src={cpIcon1} alt="illustration" />
                            <h6 className="main-color">From Basics To Advanced</h6>
                            <p>
                                Our course is designed to take you from novice to professional, regardless of your prior knowledge or no knowledge at all, we have designed our course to take you from the foundation to the top- ensuring you have adequate knowledge to participate in everything forex and it doesn’t stop there as there are other educational security add one of being enrolled in our academy.
                            </p>
                        </div>
                        <div className="cp-card">
                            <img src={timingIcon} alt="illustration" />
                            <h6 className="main-color">Learn At Your Pace</h6>
                            <p>
                                Signing up for our course gives you access to the resources at any time and any day. You will be able you learn at your convenience and your own pace, also enabling you to go over the course as many times as you desire.
                            </p>
                        </div>
                        <div className="cp-card">
                            <img src={communityIcon} alt="illustration" />
                            <h6 className="main-color">Interractive Community</h6>
                            <p>
                                Since learning is a constant factor in this business, and one of our values here is teamwork, we have made available an organized system and platform for our enrolled students to converse, share ideas, keep themselves updated and collaborate while being supervised as we make sure that no question requiring clarity is left unanswered.
                        </p>
                        </div>
                    </div>
                </div>
                <div className="free-webinar">
                    <div className="webinar-image" data-aos="zoom-in-right" data-aos-delay="100" data-aos-duration="1800">
                        <img src={composition} />
                    </div>
                    <div className="fw-text" data-aos="fade-up" data-aos-delay="100" data-aos-duration="2000">
                        <h2 className="main-color">Our Daily & Weekly Free Webinar & Live Sessions.</h2>
                        <ul className="webinar-list">
                            <li>
                                <img src={checkmark} alt="checkmark" />
                                <p>Interactive session about the recent happenings in the market</p>
                            </li>
                            <li>
                                <img src={checkmark} alt="checkmark" />
                                <p>Market Analysis and set-up reviews</p>
                            </li>
                            <li>
                                <img src={checkmark} alt="checkmark" />
                                <p>Q&A Sessions</p>
                            </li>
                        </ul>
                        <div className="fw-button">
                            <Link to="/webinar">
                                <Button className="webinar-btn">
                                    <p>See Past Webinar</p>
                                    <img src={arrowright} alt="arrow right" />
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="channel">
                    <div className="channel-background" data-aos="zoom-in-left" data-aos-delay="100" data-aos-duration="1800">
                        <img src={telegramchannel} alt="phone mock" />
                    </div>
                    <div className="channel-benefits" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1500">
                        <h1 className="main-color">OUR TELEGRAM CHANNEL</h1>
                        <h6>On this platform, we send out updates and information, but, there’s more!<br /><br /> We analyze the markets and keep a close watch on what’s happening in the global economic world to complement our analysis to provide the best information on our trading set-ups and accurate trade calls. We provide every detail necessary; from the Entry prices, the stop-loss price to take profit prices.</h6>
                        <ul className="benefits-list">
                            <li>
                                <img src={checkbox} alt="checkbox icon" />
                                <h6>Technical analysis setups & Signals</h6>
                            </li>
                            <li>
                                <img src={checkbox} alt="checkbox icon" />
                                <h6>Signal calls with the best RR (5-15 pips stop loss)</h6>
                            </li>
                            <li>
                                <img src={checkbox} alt="checkbox icon" />
                                <h6>90% win rate and accuracy</h6>
                            </li>
                            <li>
                                <img src={checkbox} alt="checkbox icon" />
                                <h6>1000+ pips weekly</h6>
                            </li>
                            <li>
                                <img src={checkbox} alt="checkbox icon" />
                                <h6>Educational material contents and vidoes</h6>
                            </li>
                        </ul>
                        <Button className="telegram-btn">
                            <p>Join Telegram channel!</p>
                        </Button>
                    </div>
                </div>
                {/* <div className="account-management">
                    <div className="account-management-content">
                        <h1>FOREX ACCOUNT MANAGEMENT</h1>
                        <h6 className="account-management-h6">Individuals who can’t trade due to tight schedules or other personal reasons, <br /> can easily sign up for our account management- we do all the work, while you <br /> watch your funds grow.</h6>
                        <div className="account-process">
                            <div className="account-overview">
                                <h4 className="signup">SIGN UP & REGISTER</h4>
                                <h6>
                                    Interested personnels are required  to fill the the necessary information  in the form that will be provided  after clicking the “get started”  button
                                <br /><br /> An email will be send to the email submitted in the form- which contains information on the next steps.
                            </h6>
                            </div>
                            <div className="account-overview">
                                <h4>CHOOSE PAYMENT  METHOD</h4>
                                <h6>
                                    Get your trading account started and  be added to the table of our trading  portfolio by making a capital deposit through the most convienient means available.
                            </h6>
                            </div>
                            <div className="account-overview">
                                <h4>GET INVESTOR LOGIN  & MONITOR PROGRESS</h4>
                                <h6>
                                    Once capital deposit is completed, the trading account will be added to our trading portfolio and the login password will be sent to the individuals who signed up for the account management.
                                <br /><br /> You’ll the able to watch and witness  how your fund is being managed.
                            </h6>
                            </div>
                        </div>
                        <div className="eligibility">
                            <h1>ELIGIBITY</h1>
                            <ul className="benefits-list">
                                <li>
                                    <img src={bulletpoint} alt="bullet point" />
                                    <h4>A minimum deposit of $50,000 (Thirty thousand USD)</h4>
                                </li>
                                <li>
                                    <img src={bulletpoint} alt="bullet point" />
                                    <h4>A maximum deposit of $500,000,000 (Three hundred million USD)</h4>
                                </li>
                                <li>
                                    <img src={bulletpoint} alt="bullet point" />
                                    <h4> A Profit/Loss share ratio of 40% for investor & 60% to the company</h4>
                                </li>
                                <li>
                                    <img src={bulletpoint} alt="bullet point" />
                                    <h4>Must have the meta trader 4 or 5 mobile application to watch funds grow</h4>
                                </li>
                                <li>
                                    <img src={bulletpoint} alt="bullet point" />
                                    <h4>A flexible payment system (Bank deposit, Bitcoin, neteller, skrill, etc)</h4>
                                </li>
                            </ul>
                            <Link to="/account">
                                <Button className="elig-button">Get Started</Button>
                            </Link>
                        </div>
                    </div>
                </div> */}
            </>
        )
    }
}

export default GetStarted;